import { get as s, set as l } from "../../../react-hook-form/dist/index.esm.js";
var f = function(r, e, i) {
  if (r && "reportValidity" in r) {
    var t = s(i, e);
    r.setCustomValidity(t && t.message || ""), r.reportValidity();
  }
}, d = function(r, e) {
  var i = function(a) {
    var o = e.fields[a];
    o && o.ref && "reportValidity" in o.ref ? f(o.ref, a, r) : o.refs && o.refs.forEach(function(n) {
      return f(n, a, r);
    });
  };
  for (var t in e.fields)
    i(t);
}, u = function(r, e) {
  e.shouldUseNativeValidation && d(r, e);
  var i = {};
  for (var t in r) {
    var a = s(e.fields, t);
    l(i, t, Object.assign(r[t] || {}, { ref: a && a.ref }));
  }
  return i;
};
export {
  u as toNestError,
  d as validateFieldsNatively
};
//# sourceMappingURL=resolvers.module.js.map
